module.exports = require("./pa.d.ts");